module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sidney Greidanus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Sidney Greidanus")]), _vm._v(" is professor emeritus of preaching at Calvin Theological Seminary and the author of several books, including "), _c('I', [_vm._v("The Modern Preacher and the Ancient Text, Preaching Christ from the Old Testament, Preaching Christ from Genesis, Preaching Christ from Ecclesiastes, Preaching Christ from Daniel,")]), _vm._v(" and "), _c('I', [_vm._v("Preaching Christ from Psalms.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/W2wSFx/tc-custom/9781467461399.jpg?1708515429900",
      "alt": "This image is the cover for the book Preaching Christ from Leviticus"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Preaching Christ from Leviticus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For pastors who take seriously the commitment to incorporate the entire"), _c('i'), _vm._v("Bible into their preaching, Sidney Greidanus’s books on preaching Christ from the major genres of the Old Testament have been a welcome gift. In his last such volume, Greidanus engages with the Old Testament genre of law and treats a book that is often seen as the most challenging of all: Leviticus. ")]), _c('p', [_c('i', [_vm._v("Preaching Christ from Leviticus ")]), _vm._v("reminds pastors and congregations that key christological themes—priesthood, sacrifice, atonement, holiness—first originated in Leviticus before they came to full flower in the New Testament with the atoning sacrifice of Jesus Christ and his call to holiness. Greidanus provides the basis for fully understanding these and other themes with an exacting analysis of Leviticus and then provides the foundations for ten sermons on Leviticus through topics such as the burnt offering, the ordained priesthood, the day of atonement, the sabbatical year, and the year of jubilee, as well as the commandments to be holy, to love your neighbor, and to love aliens and enemies.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0